package features.shifts.domain

data class ShiftTemplate(
    val id: String,
    val code: String,
    val color: String,
    val startTime: String,
    val endTime: String
)
